// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import '../static/theme/index.css'

Vue.use(ElementUI)

Vue.config.productionTip = false
Vue.config.debug = true;
Vue.config.devTools = true;

const { state } = store

if ( !state.bootstraped ) {
	router.push('/')
}

/* eslint-disable no-new */
let vm = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})

window.vm = vm;


// WEBPACK FOOTER //
// ./src/main.js